<template>
  <div class="role-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.uuid != null">

              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name"
                                aria-describedby="nameFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('description')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.description">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('code')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.code" readonly>
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('active')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" v-model="item.active"
                            v-bind:checked="item.active" :value="1" :uncheckedValue="0"/>
                </b-form-group>

              </b-col>

              <b-col cols="12">
                <hr/>
              </b-col>
              <div class="col-12">
                <label class="switch switch-icon switch-primary">
                  <input type="checkbox" class="switch-input" @change="checkAll">
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
                <legend class="col-form-label"><b>All</b>
                </legend>
              </div>
              <div class="col-3" v-for="permission in permissionsData" :key="permission.code">
                <label
                  class="switch switch-icon switch-primary">
                  <input type="checkbox" class="switch-input" v-model="item.permissionIds" v-bind:value="permission.id">
                  <span data-on="" data-off="" class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
                <legend class="col-form-label">{{permission.name}}
                  <small class="text-muted">{{ permission.description }}</small>
                </legend>
              </div>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}">
                <b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button>
              </router-link>
              <b-button variant="success" v-on:click="updateItem" v-if="uuid != null && $auth.check(model + '.update')">
                <i class="fa fa-save"></i> {{$t('update')}}
              </b-button>
              <b-button variant="success" v-on:click="createItem" v-if="uuid == null && $auth.check(model + '.create')">
                <i class="fa fa-save"></i> {{$t('save')}}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .switch {
    margin-bottom: 0px;
    margin-top: 7px;
    float: left;
    margin-right: 5px;
  }
</style>
<script>
  import cSwitch from '../../../components/Switch'
  import {get, create, update, getRolePermission, getRole} from '@/api/role'
  import {getPermissionList} from '@/api/permission'

  export default {
    name: 'RoleForm',
    props: {
      uuid: {
        type: String,
        default: null
      }
    },
    components: {
      cSwitch
    },
    computed: {},
    data: function () {
      return {
        model: 'role',
        permissionsData: [],
        item: {
          uuid: null,
          name: '',
          description: '',
          code: '',
          active: 0,
          permissionIds: []
        },
        languages: Object.keys(this.$i18n.messages)
      }
    },
    methods: {
      /**
       * Check on/off of permission switch
       * @param id of permission
       * @returns {boolean}
       */
      checkPermission(id) {
        if (_.indexOf(this.item.permissionIds, id) >= 0) {
          return true
        }
        return false
      },
      /**
       * Get details of object
       */
      getDetails() {
        let self = this
        this.$Progress.start()
        let data = {
          uuid: this.uuid
        }
        get(data).then((response) => {
          this.$Progress.finish()
          this.item.uuid = response.data.data.uuid
          this.item.name = response.data.data.name
          this.item.description = response.data.data.description
          this.item.code = response.data.data.code
          this.item.active = response.data.data.active
          response.data.data.permissions.forEach(function (item) {
            self.item.permissionIds.push(item.id)
          })
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * List permission
       */
      getPermission() {
        this.$Progress.start()
        getPermissionList().then((response) => {
          this.$Progress.finish()
          this.permissionsData = response.data.data
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },

      /**
       * Update permission of Role
       * @param val of switch
       */
      checkAll(val) {
        this.item.permissionIds = [];
        if (val.target.checked) {
          for (let i in this.permissionsData) {
            this.item.permissionIds.push(this.permissionsData[i].id)
          }
        }
      },
      /**
       * Update item info to server
       */
      updateItem() {
        this.$Progress.start()
        update(this.item).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Create item info to server
       */
      createItem() {
        this.$Progress.start()
        create(this.item).then((response) => {
          this.$notify({
            title: this.$t('success'),
            text: response.data.message,
            type: 'success'
          })
          this.$router.push({name: this.model})
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      this.getDetails()
      this.getPermission()
    },
    watch: {
      'item.name': function () {
        this.item.code = this.item.name.trim().toLowerCase().replace(/ /g, '.')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/role/Form.vue